import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll olayını dinle
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Yukarı çık fonksiyonu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top"
          aria-label="Yukarı çık"
        >
          <i className="fas fa-chevron-up"></i>
        </button>
      )}

      <style>
        {`
          .scroll-to-top {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background-color: var(--kito-orange);
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            z-index: 1000;
            opacity: 0.9;
          }

          .scroll-to-top:hover {
            transform: translateY(-3px);
            opacity: 1;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
          }

          @media (max-width: 768px) {
            .scroll-to-top {
              bottom: 15px;
              right: 15px;
              width: 35px;
              height: 35px;
              font-size: 16px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ScrollToTop; 